import { render, staticRenderFns } from "./department-child-add.vue?vue&type=template&id=2e48ffe6&scoped=true&"
import script from "./department-child-add.vue?vue&type=script&lang=js&"
export * from "./department-child-add.vue?vue&type=script&lang=js&"
import style0 from "./department-child-add.vue?vue&type=style&index=0&id=2e48ffe6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e48ffe6",
  null
  
)

export default component.exports